query propstackConfig($companyId: ID!) {
  propstackConfig(companyId: $companyId) {
    token
    isTokenVerified
    selectedContactStatusIds
    selectedGroupIds
    isManagedByParent
    isMultiCompanyParent
    teamId
  }
}
